import { render, staticRenderFns } from "./earthDetail.vue?vue&type=template&id=79a195a6&scoped=true"
import script from "./earthDetail.vue?vue&type=script&lang=js"
export * from "./earthDetail.vue?vue&type=script&lang=js"
import style0 from "./earthDetail.vue?vue&type=style&index=0&id=79a195a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a195a6",
  null
  
)

export default component.exports